module.exports = __webpack_public_path__ + "img/cs-images.c44af244.jpg";